import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerCommunication {
  private numberRequests: number = 0;

  public get IsHidden(): boolean {
    return this.numberRequests === 0;
  }

  public show() {
    this.numberRequests++;
  }

  public hide() {
    this.numberRequests--;
  }
}
